<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRefEventListener } from 'JIX/eventListener.js';

const open = defineModel('open', Boolean);

const modal = ref();

const headerRef = ref();

function viewportHandler() {
    const offsetLeft = window.visualViewport.offsetLeft;
    const offsetTop = window.visualViewport.offsetTop;

    if (headerRef.value){
        headerRef.value.style.transform = `translate(${offsetLeft}px, ${offsetTop}px)`;
    }
}

function cleanUp() {
    if (window.visualViewport) {
        window.visualViewport.removeEventListener("scroll", viewportHandler);
        window.visualViewport.removeEventListener("resize", viewportHandler);
    }
}

onMounted(() => {
    watch(open, () => {
        if (open.value) {
            modal.value?.showModal();
            window.visualViewport.addEventListener("scroll", viewportHandler);
            window.visualViewport.addEventListener("resize", viewportHandler);
        } else {
            cleanUp();
            modal.value?.close();
        }
    }, { immediate: true, flush: 'post' });
});

onBeforeUnmount(() => {
    cleanUp();
});

useRefEventListener(modal, 'close', () => open.value = false);
</script>

<template>
    <dialog
        class="fullscreen-overlay"
        ref="modal"
        v-if="open"
    >
        <div class="fullscreen-overlay__header" ref="headerRef">
            <slot name="header" />
        </div>
        <div class="fullscreen-overlay__body">
            <slot name="body" />
        </div>
        <div class="fullscreen-overlay__footer">
            <slot name="footer" />
        </div>
    </dialog>
</template>
